<script setup>

// 合作伙伴
const props = defineProps({
    partner: {
        type: Array,
        required: true,
        default: () => [],
    },
    footer: {
        type: Object,
        default: () => ({ webname: '盒子云' })
    }
})

</script>

<template>
    <div class="Heziyun-partners Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('index.cooperativePartner3') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{ $t('index.cooperativePartner4') }}</p>
            </div>

            <div class="Heziyun-partners-list" v-intersect="{ class: 'bottom-top', delay: 100 }">
                <a v-for="(item, index) in partner" :href="item.url" target="_blank">
                    <a-image :src="item.img" show-loader :preview="false" />
                </a>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
// 合作伙伴
.Heziyun-partners {
    background: url('../../static/img/index/cooperativePartnerTwo.jpg') no-repeat center;
    background-size: cover;

    .Heziyun-defaultWidth {
        .Heziyun-partners-list {
            display: grid;
            grid-template-columns: repeat(8, 1fr);

            a {
                background-color: rgba(255, 255, 255, 0.63137255);
                backdrop-filter: blur(20px);
                height: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid #eaeaea;
                position: relative;

                &:hover {
                    box-shadow: 0 5px 20px #9090907d, 0 0 2px #25386c1a;
                    z-index: 1;
                }

                :deep(.arco-image) {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                :deep(.arco-image-img) {
                    max-width: 70%;
                    max-height: 50%;
                }

                img {
                    max-width: 70%;
                    max-height: 50%;
                }
            }
        }
    }
}

@media (max-width: 768px) {

    // 合作伙伴
    .Heziyun-partners {

        .Heziyun-defaultWidth {
            .Heziyun-partners-list {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
            }
        }
    }
}
</style>